// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';
import type { PriceProps } from '../../../types';
import Price from './price';

const StyledPrice = styled<typeof Price, Theme, _>(Price)`
  text-decoration: line-through;
  color: ${props => props.theme.configColor.fromPrice.color};
`;

export default ({ amount, ...props }: PriceProps) => (
  amount ? (<StyledPrice amount={amount} {...props} />) : null
);
